import React, { Component } from "react";
import {
	Card,
	Switch,
	Button,
	InputGroup,
	FormGroup,
	Icon,
	Spinner,
} from "@blueprintjs/core";

export default class GameInfoPlayers extends Component {
	state = {
		hoveredPosition: null,
		contextPlayer: null,
		contextPos: null,
		tshirtHoveredPosition: null
	};



	componentDidMount() {
		document.addEventListener("click", this.closeContextMenu);
		document.addEventListener("keydown", this.onEsc, true);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.tshirtHoveredPosition !== this.props.tshirtHoveredPosition) {
			this.setState({ tshirtHoveredPosition: this.props.tshirtHoveredPosition });
		}
	}

	componentWillUnmount() {
		document.removeEventListener("click", this.closeContextMenu);
		document.removeEventListener("keydown", this.onEsc, true);
	}

	onEsc = (e) => {
		if (e.key === "Escape") this.setState({ contextPlayer: null });
	};


	closeContextMenu = () => {
		this.setState({ contextPlayer: null });
	};

	copyPlayersToClipboard = () => {
		const { players } = this.props;

		// Filter convocat players
		const convocati = players.filter(p => p.status === "convocat");

		// Sort: GK first, then by birth_date desc
		const sorted = [
			...convocati.filter(p => p.position === "GK" || p.default_position === "GK"),
			...convocati
				.filter(p => p.position !== "GK" && p.default_position !== "GK")
				.sort((a, b) => new Date(a.birth_date) - new Date(b.birth_date))
		];

		const list = sorted.map((p, idx) => `${idx + 1}. ${p.name}`).join("\n");

		navigator.clipboard.writeText(list)
			.then(() => console.log("Lista convocatilor a fost copiata in clipboard"))
			.catch(err => console.error("Eroare la copiere:", err));
	};

	render() {
		const { players } = this.props;
		const { hoveredPosition, contextPlayer, contextPos } = this.state;
		const { tshirtHoveredPosition } = this.state;
		// console.log(players)
		return (
			<div className="all-players-col">
				<div className="sidebar-content">
					
					{
						players?.filter(p => p.is_substitute === 1)?.length
							? <>
								<p className='f-2'>Rezerve</p>
								<div className="p-bottom-2-rem width-max-content">
									{players.filter(p => p.is_substitute === 1).sort((a, b) => {
										// 1. Portarii primii
										if ((a.position || a.default_position) === "GK" && (b.position || b.default_position) !== "GK") return -1;
										if ((a.position || a.default_position) !== "GK" && (b.position || b.default_position) === "GK") return 1;

										// 2. Ordinea după vârstă (cel mai în vârstă primul)
										return new Date(a.birth_date) - new Date(b.birth_date);
									}).map((p, idx) => {
										return <div
											key={p.id}
											className="l1-list-item"
											onMouseEnter={() => this.props.setPlayerHovered(p.position || p.default_position, true)}
											onMouseLeave={() => this.props.setPlayerHovered(p.position || p.default_position, false)}
											onClick={() => this.props.onChange(p.id, "position", p.default_position)}
											onContextMenu={(e) => {
												e.preventDefault();
												this.setState({ contextPlayer: p, contextPos: { x: e.clientX, y: e.clientY } });
											}}
										>
											<span className='f-3'>{idx + 12}</span>
											<span className={tshirtHoveredPosition === (p.position || p.default_position) ? 'f-5' : 'f-4'}>{p.name}</span>
										</div>
									}

									)}
								</div>
							</>
							: ''
					}


					<p className='f-2'>{players.filter(p => p.status === 'convocat')?.length ? 'Neconvocati' : 'Jucători'}</p>
					<div className='shaddow-box p-bottom-1-rem width-max-content'>
						{players.filter(p => (!p.position && !p.is_substitute && p.status !== "absent")).sort((a, b) => {
							// 1. Portarii primii
							if ((a.position || a.default_position) === "GK" && (b.position || b.default_position) !== "GK") return -1;
							if ((a.position || a.default_position) !== "GK" && (b.position || b.default_position) === "GK") return 1;

							// 2. Ordinea după vârstă (cel mai în vârstă primul)
							return new Date(a.birth_date) - new Date(b.birth_date);
						}).map((p, idx) => {
							return <div
								key={p.id}
								className="l1-list-item"
								onMouseEnter={() => this.props.setPlayerHovered(p.position || p.default_position, true)}
								onMouseLeave={() => this.props.setPlayerHovered(p.position || p.default_position, false)}
								onClick={() => this.props.onChange(p.id, "position", p.default_position)}
								onContextMenu={(e) => {
									e.preventDefault();
									this.setState({ contextPlayer: p, contextPos: { x: e.clientX, y: e.clientY } });
								}}
							>
								<span className='f-3'>{idx + 1}. </span>
								<span className={tshirtHoveredPosition === (p.position || p.default_position) ? 'f-5' : 'f-4'}>{p.name}</span>
								{p.status === "accidentat" && <Icon icon='symbol-cross' size='22' />}
								{p.status === "suspendat" && <Icon icon="blocked-person" size='20' />}
							</div>

						})}
					</div>

					{
						players?.filter(p => p.status === 'absent')?.length
							? <>
								<p className='f-2'>Absenti</p>
								<div className='shaddow-box p-bottom-1-rem width-max-content'>
									{players.filter(p => (p.status === "absent")).map((p, idx) => {
										return <div
											key={p.id}
											className="l1-list-item"
											onMouseEnter={() => this.props.setPlayerHovered(p.position || p.default_position, true)}
											onMouseLeave={() => this.props.setPlayerHovered(p.position || p.default_position, false)}
											onClick={() => this.props.onChange(p.id, "position", p.default_position)}
											onContextMenu={(e) => {
												e.preventDefault();
												this.setState({ contextPlayer: p, contextPos: { x: e.clientX, y: e.clientY } });
											}}
										>
											<span className='f-3'>{idx + 1}. </span>
											<span className={tshirtHoveredPosition === (p.position || p.default_position) ? 'f-5' : 'f-4'}>{p.name}</span>
											{p.status === "accidentat" && <Icon icon='symbol-cross' size='22' />}
										</div>

									})}
								</div>
							</>
							: ''
					}
					<button className="uecl-button-outline"
						onClick={() => this.copyPlayersToClipboard()}
						title="Copiază jucătorii">
						Copy
					</button>
				</div>

				{contextPlayer && contextPos && (
					<div
						className="ucl-menu-backdrop"
						onClick={() => this.setState({ contextPlayer: null })}
					>
						<div
							className="ucl-menu"
							style={{ top: contextPos.y, left: contextPos.x }}
							onClick={e => e.stopPropagation()}
							role="menu"
						>
							<div className="ucl-menu-header">
								<div className="ucl-avatar">{(contextPlayer.name || "?").slice(0, 1)}</div>
								<div className="ucl-meta">
									<div className="ucl-name">{contextPlayer.name}</div>
									<div className="ucl-sub">
										{contextPlayer.position || "Fără poziție"} · {contextPlayer.is_substitute ? "Rezervă" : "Jucător"}
									</div>
								</div>
							</div>

							{/* GRID cu poziții */}
							<div className="ucl-grid">
								{["GK", "FD", "FCD", "FCS", "FS", "MC", "AD", "ID", "AC", "IS", "AS"].map(pos => (
									<button
										key={pos}
										className={`ucl-cell ${contextPlayer.position === pos ? "active" : ""}`}
										onClick={() => {
											this.props.onChange(contextPlayer.id, "position", pos, { force: true });
											if (contextPlayer.is_substitute === 1) {
												this.props.onChange(contextPlayer.id, "is_substitute", 0, { force: true });
											}
											this.setState({ contextPlayer: null });
										}}
									>
										{pos}
									</button>
								))}
							</div>

							{/* acțiuni rapide */}
							<div className="ucl-actions">
								<button
									className="ucl-action"
									onClick={() => {
										// respectă limita de 9 rezerve (fără force:true)
										this.props.onChange(contextPlayer.id, "is_substitute", 1);
										this.setState({ contextPlayer: null });
									}}
								>
									Rezervă
								</button>

							</div>
							<div className="ucl-divider" />
							<div className="ucl-actions">
								<button
									className="ucl-action warn"
									onClick={() => {
										this.props.onChange(contextPlayer.id, "status", "accidentat");
										this.props.onChange(contextPlayer.id, "is_substitute", 0, { force: true });
										this.setState({ contextPlayer: null });
									}}
								>
									Accidentat
								</button>
								<button
									className="ucl-action"
									onClick={() => {
										this.props.onChange(contextPlayer.id, "status", "invoit");
										this.props.onChange(contextPlayer.id, "is_substitute", 0, { force: true });
										this.setState({ contextPlayer: null });
									}}
								>
									Învoit
								</button>
								<button
									className="ucl-action"
									onClick={() => {
										this.props.onChange(contextPlayer.id, "status", "absent");
										this.props.onChange(contextPlayer.id, "is_substitute", 0, { force: true });
										this.setState({ contextPlayer: null });
									}}
								>
									Absent
								</button>
								<button
									className="ucl-action"
									onClick={() => {
										this.props.onChange(contextPlayer.id, "status", "neconvocat");
										this.props.onChange(contextPlayer.id, "is_substitute", 0);
										this.setState({ contextPlayer: null });
									}}
								>
									Neconvocat
								</button>
							</div>
						</div>
					</div>
				)}


			</div>
		);
	}
}